const SHOPIFY_PRICE_LIST_SLUG = 'spark-shopify-price';
const SHOPIFY_COMPARE_AT_PRICE_LIST_SLUG = 'spark-shopify-compare-at-price';

export const SHOPIFY_PRICE_LISTS = [
  SHOPIFY_PRICE_LIST_SLUG,
  SHOPIFY_COMPARE_AT_PRICE_LIST_SLUG,
] as const;

export const SHOPIFY_ADMIN_FALLBACK_URL = 'https://admin.shopify.com';

export { SAVE_BAR_ID } from '@sparklayer-io/spark-dash-ui/lib/save-bar';
